import React from "react";
import CpntSubHeader from "./CpntSubHeader";
import { IBreadCrumbs } from "../models/interfaces/IBreadCrumbs";


interface IProps {
  children: React.ReactNode;
  ReturnPath: string;
  ReturnTitle?: string;
  ReturnClass?: string;
  BreadCrumbs?: IBreadCrumbs[];
  goBack?: boolean;
}

const CpntPage: React.FC<IProps> = ({
  ReturnPath,
  ReturnTitle,
  ReturnClass,
  BreadCrumbs,
  goBack,
  children
}) => {
  return (
    <>
      {(ReturnPath || BreadCrumbs || goBack) && (
        <CpntSubHeader
          ReturnPath={ReturnPath}
          ReturnTitle={ReturnTitle}
          ReturnClass={ReturnClass}
          BreadCrumbs={BreadCrumbs}
          goBack={goBack}
        />
      )}
      {React.Children.map(children, (child) => {
        if (child) {
          return <>{child}</>;
        }
      })}
    </>
  );
};

export default CpntPage;
